export default __webpack_public_path__ + "1bcce44.png";